export default "__VITE_ASSET__CvMVS0VY__"